<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-4
      .col
        router-link.button-previous.mr-2(to="/seguimiento-diario/id")
          i.fas.fa-chevron-left
        h3.m-0.d-inline-block.align-middle
          i {{$route.name}}
        br
        h1.d-inline-block.m-0
          i {{detail.user_leader.name}}
        //- h3.d-inline-block.ml-4 I.A {{detail.objective.ica}}%
      .col-auto
        .d-flex.justify-content-end.mb-2
          //- button.btn.btn__small.btn-secondary.font-italic
          //-   | Exportar
          //-   i.fas.fa-file-download.ml-2
        .card.ad_border1-secondary.rounded-xl
          h4
            i Objetivos
              .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(objective, index) in detail.objective")
                form
                  .d-flex.row.form-group.align-items-end.mb-1
                    .col
                      label
                        a(:id="'viaje' + index")
                          i.icon-letters.icon-letters__viaje V
                          i.icon-letters.icon-letters__producto.mx-1 P
                          i.icon-letters.icon-letters__segmento S
                        b-tooltip(:target="'viaje' + index" , placement='top')
                          | {{objective.travel.name}} + {{objective.product.name}} + {{objective.segment.name}}
                      label.ml-2
                        a(:id="'kpineg' + index")
                          i.icon-letters.icon-letters__negocio.mr-1 N
                        b-tooltip(:target="'kpineg' + index", placement="top")
                          | {{objective.business_type.name}}
                        | {{ objective.kpi.name }}
                        //- h4
                        //-   small KPI Personal : 
                        //-   | {{detail.objective.kpipercentage}}%
        h3 Fecha de ejecucion: {{ detail.date }}
    section
      .d-flex.row.flex-row
        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h4.m-0.ad_text-primary
                  i Problemas & Oportunidades 
                h4.ad_text-secondary
                  i Detección de Problemas* 
                  small (Obligatorio)
              .col-12
                p.mb-1 
                  | Considerando los indicadores con bajo cumplimiento, ¿Existe algún problema que te ha impedido realizar correctamente tu trabajo y no cumplir con las metas definidas?
                h4
                  small Ej. Herramientas, Materiales, Camioneta, Procedimientos, Clientes. Se pide describir el problema para poder tomar acciones sobre ellos y solicitar al técnico que entregue evidencias que demuestren la ocurrencia de estos problemas.
              
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  h4.ad_text-secondary
                    i Previos
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Descripción
                        th Clasificación
                        th Responsable
                        th Fecha de ingreso
                        //- th Semana
                        th
                    tbody
                      tr(v-for="pendingProblem in detail.pendingProblems")
                        td
                          div.py-2
                            | {{ pendingProblem.description }}
                        td
                          div
                            | {{ pendingProblem.clasification }}
                        td
                          div
                            | {{ pendingProblem.responsible.name }}
                        td
                          div
                            | {{moment(pendingProblem.date).format("DD/MM/YYYY")}}
                        td
                          div.ad_text-danger
                            //- | 2 &deg; sem
                        td.text-right
                          div
                            //- a.no-decoration(href="#" title="Comentarios" @click.stop='drawerProblemasComentarios = !drawerProblemasComentarios; nameSection(data)')
                            //-   i.icono.icono-comentarios.ad_text-primary
                      
              .row.mt-4
                .col
                  h4.ad_text-success
                    i Creados
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Descripción
                        th Clasificación
                        th Responsable
                        th
                    tbody
                      tr(v-for="newProblem in detail.newProblems")
                        td
                          div.py-2
                            | {{ newProblem.description }}
                        td
                          div
                            | {{ newProblem.clasification }}
                        td
                          div
                            | {{ newProblem.responsible.name }}
      .d-flex.row.flex-row
        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h3.ad_text-primary
                  i Problemas & Oportunidades 
                h4.ad_text-secondary
                  i Oportunidades de mejora* 
                  small (Obligatorio)
              .col-12
                p.mb-1 
                  | Considerando la respuesta anterior, ¿crees que se debe realizar alguna modificación en el procedimiento que te permita mejorar tu desempeño y entregar un mejor servicio a nuestros clientes?
                h4
                  small 
                    | Anotar las oportunidades de mejora, solicitar al técnico que entregue evidencia de casos que demuestren las malas prácticas o problemas asociadas a estas mejoras propuestas.

      .col.collapsible.ad_bg-gray.mt--3.px-0(:class="{'collapsed' : oportunidades}")
        .card-body
          .row
            .col
              h3.ad_text-danger 
                i Pendientes
              p.text-center.ad_text-grayLight.font-italic(v-if="detail.pendingOpportunities == ''")
                | Aún no tienes Oportunidades de mejora pendientes
              table.w-100.text-left.table-rounded-body(v-if="detail.pendingOpportunities != ''")
                thead
                  tr
                    th Descripción
                    th Clasificación
                    th Responsable
                    th Fecha de ingreso
                tbody
                  tr(v-for="po in detail.pendingOpportunities")
                    td
                      div.py-2
                        | {{ po.description }}
                    td
                      div
                        | {{ po.clasification }}
                    td
                      div
                        | {{ po.responsible.name }}
                    td
                      div
                        | {{moment(po.date).utc().format("DD/MM/YYYY")}}

          .row.mt-4
            .col
              h3.ad_text-success 
                i Nuevos
              p.text-center.ad_text-grayLight.font-italic(v-if="detail.newOpportunities == ''")
                | No hay oportunidades de mejora nuevos
              table.w-100.text-left.table-rounded-body(v-if="detail.newOpportunities != ''")
                thead
                  tr
                    th Descripción
                    th Clasificación
                    th Responsable
                tbody
                  tr(v-for="op in detail.newOpportunities")
                    td
                      div.py-2
                        | {{ op.description }}
                    td
                      div
                        | {{ op.clasification }}
                    td
                      div
                        | {{ op.responsible.name }}          

        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h4.m-0.ad_text-primary
                  i Compromisos Colaborador
              
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  h4.ad_text-secondary
                    i Previos
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th(width="60%") Compromisos
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        //- th Semana
                        th
                    tbody
                      tr(v-for="pendingColabCommitment in detail.pendingColabCommitments")
                        td
                          div.py-2
                            | {{ pendingColabCommitment.description }}
                        td
                          div
                            | {{moment(pendingColabCommitment.creation_date).format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendingColabCommitment.scheduled).format("DD/MM/YYYY")}}
                        td
                          div.ad_text-danger
                            //- | 2&deg; sem
                        td.text-right
                          div
                            //- a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
                            //-   i.icono.icono-comentarios.ad_text-primary
                      
              .row.mt-4
                .col
                  h4.ad_text-success
                    i Creados
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th(width="60%") Compromisos
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th
                    tbody
                      tr(v-for="newColabCommitment in detail.newColabCommitments")
                        td
                          div.py-2
                            | {{ newColabCommitment.description }}
                        td
                          div
                            | {{moment(newColabCommitment.creation_date).format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(newColabCommitment.scheduled).format("DD/MM/YYYY")}}
                        td.text-right
                          div
                            //- a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
                            //-   i.icono.icono-comentarios.ad_text-primary
                      
        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h4.m-0.ad_text-primary
                  i Compromisos Líder
              
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  h4.ad_text-secondary
                    i Previos
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th(width="60%") Compromisos
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        //- th Semana
                        th
                    tbody
                      tr(v-for="pendingLeaderCommitment in detail.pendingLeaderCommitments")
                        td
                          div.py-2
                            | {{ pendingLeaderCommitment.description }}
                        td
                          div
                            | {{moment(pendingLeaderCommitment.creation_date).format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendingLeaderCommitment.scheduled).format("DD/MM/YYYY")}}
                        td
                          div.ad_text-danger
                            //- | 2&deg; sem
                        td.text-right
                          div
                            //- a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
                            //-   i.icono.icono-comentarios.ad_text-primary
                      
              .row.mt-4
                .col
                  h4.ad_text-success
                    i Creados
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th(width="60%") Compromisos
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th
                    tbody
                      tr(v-for="newLeaderCommitment in detail.newLeaderCommitments")
                        td
                          div.py-2
                            | {{ newLeaderCommitment.description }}
                        td
                          div
                            | {{moment(newLeaderCommitment.creation_date).format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(newLeaderCommitment.scheduled).format("DD/MM/YYYY")}}
                        td.text-right
                          div
                            //- a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
                            //-   i.icono.icono-comentarios.ad_text-primary

        //- .col-12
        //-   .card.ad_border1-secondaryLight.rounded-xl.mb-0.mt-4.position-relative.off-position
        //-     .row.d-flex.align-items-top.py-2
        //-       .col
        //-         h4.m-0.ad_text-primary
        //-           i Objetivos de Desarrollo Personal
              
        //-   .col.collapsible.ad_bg-gray.px-0.mt--3
        //-     .card-body
        //-       .row
        //-         .col
        //-           h4.ad_text-secondary
        //-             i Previos
        //-           table.w-100.text-left.table-rounded-body
        //-             thead
        //-               tr
        //-                 th(width="60%") Compromisos
        //-                 th Categoría
        //-                 th Fecha de ingreso
        //-                 th Semana
        //-                 th
        //-             tbody
        //-               tr
        //-                 td
        //-                   div
        //-                     | {{ lorem | truncate(100, '...') }}
        //-                 td
        //-                   div
        //-                     | Categoría del objetivo
        //-                 td
        //-                   div
        //-                     | {{moment().format("DD/MM/YYYY")}}
        //-                 td
        //-                   div.ad_text-danger
        //-                     | 2&deg; sem
        //-                 td.text-right
        //-                   div
        //-                     a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
        //-                       i.icono.icono-comentarios.ad_text-primary
                      
        //-       .row.mt-4
        //-         .col
        //-           h4.ad_text-success
        //-             i Creados
        //-           table.w-100.text-left.table-rounded-body
        //-             thead
        //-               tr
        //-                 th(width="60%") Compromisos
        //-                 th Categoría
        //-                 th Fecha de ingreso
        //-                 th
        //-             tbody
        //-               tr
        //-                 td
        //-                   div
        //-                     | {{ lorem | truncate(100, '...') }}
        //-                 td
        //-                   div
        //-                     | Categoría del objetivo
        //-                 td
        //-                   div
        //-                     | {{moment().format("DD/MM/YYYY")}}
        //-                 td.text-right
        //-                   div
        //-                     a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
        //-                       i.icono.icono-comentarios.ad_text-primary

        
            
    v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Cerrar {{data}}
      section.py-4.px-2.overflowy-auto
        .row.mx-0.align-items-start
          .col-7
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Responsable
              span.ad_text-grayDark Jefatura
          .col-5
            c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
            c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Objetivo
              span.ad_text-grayDark 
                i.far.fa-square
                |  Viaje
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup 
              span.ad_text-grayDark 
                i.far.fa-square
                |  KPI de Negocio1 KPI Adherencia
        .row.mx-0.align-items-end
          .col-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de ingreso
              span.ad_text-grayDark 
                | 02-01-2019
          .col
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de compromiso
              span.ad_text-grayDark 
                | 02-01-2019 
                span.ad_text-danger.font-italic  2&deg; sem
        .col-12.mt-5
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Comentarios
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
    
    v-navigation-drawer(v-model='drawerCompromiso', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col.mb-3
          p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
            sup Responsable
            span.ad_text-grayDark Jefatura
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Objetivo
              span.ad_text-grayDark 
                i.far.fa-square
                |  Viaje
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup 
              span.ad_text-grayDark 
                i.far.fa-square
                |  KPI de Negocio1 KPI Adherencia
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawerCompromiso = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="drawerCompromiso = false")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.

    v-navigation-drawer(v-model='drawerProblemasComentarios', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentario {{data}}
      section.py-4.px-2.overflowy-auto
        .row.mx-0.align-items-start
          .col-12.mb-3
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Responsable
              span.ad_text-grayDark Jefatura
          .col-12.mb-3
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Observador
              span.ad_text-grayDark Francisco G
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.align-items-end
          .col
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de ingreso
              span.ad_text-grayDark 
                | 02-01-2019 
                span.ad_text-danger.font-italic  2&deg; sem
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
    
    v-navigation-drawer(v-model='drawerProblemasCerrar', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Cerrar {{data}}
      section.py-4.px-2.overflowy-auto
        .row.mx-0.align-items-start
          .col-7
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Responsable
              span.ad_text-grayDark Jefatura
          .col-5
            c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
            c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
        .row.mx-0.align-items-start
          .col-12.mb-3
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Observador
              span.ad_text-grayDark Francisco G
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.align-items-end
          .col
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de ingreso
              span.ad_text-grayDark 
                | 02-01-2019 
                span.ad_text-danger.font-italic  2&deg; sem
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Comentarios
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.

</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {

  name: 'SeguimientoDiarioDetail',
  components: {
  },
  data () {
    return {
      detail: [],
      menu: false,
      date: null, 
      compromiso: true,
      problemas: true,
      otros: true,
      lorem: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores deserunt quos laboriosam ratione repellendus consequatur saepe error dolorum incidunt? Quaerat nemo assumenda ut commodi quidem dolores quos, et numquam ad.',
      value: { value: 'Francisco Gutierrez', label: 'Francisco Gutierrez' },
      responsable: '',
      responsables: ['Responsable 1','Responsable 2','Responsable 3',],
      observador: '',
      observadores: ['Observador 1','Observador 2','Observador 3',],
      objetivo: '',
      objetivos: [ 'Objetivo 1','Objetivo 2','Objetivo 3', ],
      drawer: null,
      drawerCompromiso: null,
      drawerProblemasComentarios: null,
      drawerProblemasCerrar: null,
    }
  },
  methods: {
    moment,
    ...mapActions('tracing', ['getHistoryDetail']),
    nameSection: function(data){
      this.data = 'Problema & Oportunidad'
    },
    nameCompromiso: function(data){
      this.data = 'Compromiso'
    },
    loadDetail(id) {
      const vm = this
      // const loading = vm.$toast.loading('Cargando Detalle...')
      vm.user = vm.$store.getters['auth/getUserInfo']; 
      vm.getHistoryDetail({id, userId: vm.user.id, type: 'SD'}).then(response => {
          vm.detail = response
          // loading.hide()
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
    },
  },
  watch: {
    moveobjetivo: function(){
      let moveobjetivo = this.moveobjetivo
      if(this.moveobjetivo === true) {
          this.$emit('can-continue', {value: true});
          this.$emit('completed-step', {value: true});
      } else {
          this.$emit('can-continue', {value: false});
      }
    },
    drawer : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
    drawerCompromiso : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id);
    this.$emit('can-continue', { value: true });
  }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/seguimiento-diario-detail.vue